import styled from 'styled-components'

import ActionButton from '../ActionButton'
import breakpoints from '../../theme/breakpoints'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.neonBlue};
  align-items: center;
  justify-content: center;
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.H5};
  color: ${({ theme }) => theme.colors.pureWhite};
  margin: 2.5rem 0;
  padding: 0 2rem;
`

export const Text = styled.div`
  ${({ theme }) => theme.textStyles.textLarge};
  margin: 0 0 2.5rem 0;
  padding-bottom: 2.5rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
  border-bottom: 0.7px solid ${({ theme }) => theme.colors.grey};
  width: 100%;
`

export const Button = styled(ActionButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1.3rem;
  padding: 0 25px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.2rem 2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`
